'use strict';
import testPaymentUiController from './test-payment-ui.controller';
export default angular.module('directives.testPaymentUi', [])
    .directive('iframeOnloadTest', [function () {
        return {
            scope: {
                callBack: '&iframeOnloadTest'
            },
            link: function (scope, element, attrs) {
                element.on('load', function () {
                    return scope.callBack();
                });
            }
        };
    }])
    .controller('testPaymentUiController', testPaymentUiController)
    .component('testPaymentUi', {
    template: require('./test-payment-ui.html'),
    controller: testPaymentUiController
})
    .name;
//# sourceMappingURL=index.js.map